import { render } from "./BurguerMenu.vue?vue&type=template&id=522137a8&scoped=true"
import script from "./BurguerMenu.vue?vue&type=script&lang=js"
export * from "./BurguerMenu.vue?vue&type=script&lang=js"

import "./BurguerMenu.vue?vue&type=style&index=0&id=522137a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522137a8"]])

export default __exports__